export enum PanelView {
  Default = 0,
  Assignment = 1,
  WhereAmIUsed = 2
}

export const PanelViewLabelMap: Record<PanelView, string> = {
  [PanelView.Default]: 'Default View',
  [PanelView.Assignment]: 'Assignment View',
  [PanelView.WhereAmIUsed]: 'Where Am I Used View'
};
